var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicktokLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7494 7.38152C14.2013 7.38522 12.6911 6.90241 11.4322 6.00129V12.286C11.4318 13.45 11.076 14.5861 10.4124 15.5425C9.74887 16.4988 8.80917 17.2298 7.71896 17.6376C6.62876 18.0455 5.44002 18.1108 4.3117 17.8248C3.18338 17.5388 2.16926 16.9152 1.40495 16.0373C0.64063 15.1594 0.162549 14.069 0.0346279 12.9121C-0.0932928 11.7551 0.135044 10.5867 0.689108 9.56304C1.24317 8.53937 2.09655 7.70924 3.13514 7.18367C4.17372 6.65809 5.34801 6.46212 6.50099 6.62195V9.78295C5.97338 9.61699 5.40683 9.62199 4.88224 9.79723C4.35765 9.97247 3.90185 10.309 3.57992 10.7587C3.25799 11.2085 3.0864 11.7484 3.08966 12.3015C3.09292 12.8546 3.27085 13.3925 3.59806 13.8384C3.92526 14.2843 4.385 14.6155 4.91162 14.7845C5.43824 14.9536 6.00481 14.9519 6.53042 14.7797C7.05603 14.6076 7.5138 14.2737 7.83836 13.8259C8.16292 13.378 8.33768 12.8391 8.33766 12.286V0H11.4322C11.43 0.261326 11.4519 0.522296 11.4976 0.779612C11.6051 1.35403 11.8287 1.90047 12.1547 2.38551C12.4806 2.87055 12.9021 3.284 13.3934 3.60056C14.0922 4.06266 14.9116 4.30896 15.7494 4.30879V7.38152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicktokLogo);
export default __webpack_public_path__ + "static/media/ticktokLogo.2c9e124f4a95cdfae3c6d9c08ab72ec4.svg";
export { ForwardRef as ReactComponent };